import produce from 'immer';
import { calculateLTV, getAssociatedAsset } from 'app/features/util/ltv';
import { GetNewLTV } from '../common/HealthFactor';
import { BigMath } from '@silo/utils';

export const getNewLTV: GetNewLTV = ({ currentLTV: { args }, normalizedTokenAmount, selectedAsset }) => {
  const newArgs = produce(args, (draft) => {
    const associatedAsset = getAssociatedAsset(draft.collateralAssets, selectedAsset);

    if (associatedAsset) {
      const newBalance = associatedAsset.balance - normalizedTokenAmount.toBigInt();

      // don't let the new collateral balance go below 0, as this results in odd calculations
      associatedAsset.balance = BigMath.max(newBalance, 0n);
    } else {
      console.warn(`siloAsset with address ${selectedAsset.assetAddress} could not be found in the asset array`);
    }
  });

  return calculateLTV(newArgs);
};
